import { useEffect, useState } from "react";
import { Banner, BlockStack, FormLayout, Modal, Spinner, Text, TextField } from "@shopify/polaris";
import supabase from "../../supabase-client";
import { payeeFormatErrors, rpcError } from "../../utility/egresos";
import PayeeFields from "./PayeeFields";

// Edit a tercero (payees). update_payee replaces every field, so the form
// starts from the stored row. Changing the name, RFC, CLABE or holder
// retires the open bank verification and queues a new one
// (trg_queue_payee_clabe_verification); the RFC, CURP, CLABE and phone are
// re-checked against every other profile so an edit can't create a duplicate.
const FIELDS = ["name", "nickname", "phone", "email", "rfc", "curp", "clabe", "bank_holder_name", "spei_concept", "notes"];

export default function EditPayeeModal({ payeeId, onClose, onSaved }) {
  const [row, setRow] = useState(null);
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  useEffect(() => {
    supabase
      .from("payees")
      .select("*")
      .eq("id", payeeId)
      .maybeSingle()
      .then(({ data }) => {
        setRow(data);
        setF(Object.fromEntries(FIELDS.map((k) => [k, data?.[k] || ""])));
      });
  }, [payeeId]);

  const save = async () => {
    setSaving(true);
    setError(null);
    const { error: err } = await supabase.rpc("update_payee", {
      p_id: payeeId,
      p: { ...f, company_id: row.company_id, customer_id: row.customer_id },
    });
    setSaving(false);
    if (err) return setError(rpcError(err));
    onSaved();
  };

  const accountChanged =
    row && ["name", "rfc", "clabe", "bank_holder_name"].some((k) => (f[k] || "") !== (row[k] || ""));

  return (
    <Modal
      open
      onClose={onClose}
      title="Editar tercero"
      primaryAction={{ content: "Guardar", onAction: save, loading: saving, disabled: !f?.name?.trim() || Object.keys(payeeFormatErrors(f || {})).length > 0 }}
      secondaryActions={[{ content: "Cancelar", onAction: onClose }]}
    >
      <Modal.Section>
        {!f ? (
          <Spinner size="small" />
        ) : (
          <BlockStack gap="300">
            {error && <Banner tone="critical">{error}</Banner>}
            {accountChanged && (
              <Text tone="caution">Al guardar se vuelve a verificar la cuenta con el banco (tarda alrededor de un minuto).</Text>
            )}
            <PayeeFields f={f} set={set} />
            <FormLayout>
              <TextField label="Notas" value={f.notes} onChange={set("notes")} multiline={2} autoComplete="off" />
            </FormLayout>
          </BlockStack>
        )}
      </Modal.Section>
    </Modal>
  );
}
